import React, { useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import FileSaver from 'file-saver';
import { LoadingPage } from 'components';
import { useQuery } from 'hooks';
import Services from './services';
import useCustomHook from './hooks';

// بررسی این‌که آیا شناسه صرفاً عددی است یا خیر
const isNumeric = (value) => /^\d+$/.test(String(value ?? '').trim());

export default function GetFile() {
  const query = useQuery();
  const params = useParams();
  const navigate = useNavigate();
  const { isLoading, setIsLoading } = useCustomHook();
  const fileIdentifier = params?.id;

  const handleDownload = (response, isNumericId) => {
    if (isNumericId) {
          const podspaceBusinessUrl = process.env?.REACT_APP_BASE_URL_UPLOAD_BUSINESS_INFO_PODSAPCE;
          window.open(`${podspaceBusinessUrl}${response?.result}` , '_blank');
    } else {
      let filename = response.headers?.['content-disposition'];
      if (filename) {
        filename = filename
          .split(';')
          .find((item) => item.includes('filename='))
          ?.replace('filename=', '')
          ?.trim();

        if (filename) {
          filename = JSON.parse(decodeURI(filename));
          const blob = new Blob([response.data]);
          FileSaver.saveAs(blob, filename);
        }
      }
    }
  };

  const getData = useCallback(async () => {
    if (!fileIdentifier) return;

    localStorage.removeItem('fileHashCode');
    localStorage.removeItem('fileHashTimeExpire');
    const isNumericId = isNumeric(fileIdentifier);

    try {
      // اگر عددی بود سرویس جدید (getFileById) وگرنه سرویس قبلی (getFile)
      const res = isNumericId
        ? await Services.getDownloadableFileUrl(fileIdentifier) // 👈 سرویس جدید برای آیدی عددی
        : await Services.getFile(fileIdentifier); // 👈 سرویس قبلی برای هش / توکن

      handleDownload(res, isNumericId);

      const redirectUrl = query?.get('redirectUrl') || '/Home';
      navigate(redirectUrl);
    } catch (error) {
      setIsLoading(false);
    }
  }, [fileIdentifier, navigate, query, setIsLoading]);

  useEffect(() => {
    getData();
  }, [getData]);

  return <>{isLoading && <LoadingPage />}</>;
}
